// removed by extract-text-webpack-plugin
module.exports = {"root":"attendee-export--root--qz3RWxcZ"};


//////////////////
// WEBPACK FOOTER
// ./views/order-detail/attendee-export/styles.css
// module id = ./views/order-detail/attendee-export/styles.css
// module chunks = 0